import React, { useState } from "react";
import s from "../../admin_styles/UserSearch.module.css";

export default function CommentModal({ userId, users, setUsers, onClose }) {
  const user = users.find((u) => u.id === userId);
  const [value, setValue] = useState(user?.comment || "");
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/admin/update_comment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: userId,
          comment: value,
        }),
      });

      const data = await res.json();

      if (data.status === "ok") {
        // 🔥 ОБНОВЛЯЕМ users прямо во фронте
        setUsers((prev) =>
          prev.map((u) =>
            u.id === userId ? { ...u, comment: value } : u
          )
        );
      }

    } catch (e) {
      console.error(e);
    }

    setLoading(false);
    onClose();
  };

  return (
    <div className={s.modalOverlay}>
      <div
        className={s.modalContent}
        onClick={(e) => e.stopPropagation()}
        style={{ width: "400px" }}
      >
        <h3>Комментарий</h3>

        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          style={{
            width: "100%",
            minHeight: "150px",
            marginTop: "10px",
          }}
        />

        <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
          <button onClick={save} disabled={loading}>
            {loading ? "Сохраняю..." : "Сохранить"}
          </button>
          <button onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
}